import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import AppLabelWithValue from 'src/components/appComponents/AppLabelWithValue';
import Label from 'src/components/label';
import { useBoolean } from 'src/hooks/use-boolean';
import { Dialog, DialogContent } from '@mui/material';
import ReactPlayer from 'react-player/youtube';

type Props = {
  suggestionVideo: any;
};

export default function ChannelAiSuggestionsInfo({ suggestionVideo }: Props) {
  const showVideo = useBoolean();

  return (
    <>
      <Grid item container mb={3} alignItems="center">
        <Grid item xs={6} md={2}>
          <Typography variant="h4" color="primary">
            Suggestion Info
          </Typography>
        </Grid>
        <Grid item xs={6} md={10}>
          <Label
            color={
              suggestionVideo?.status == 'Pending'
                ? 'warning'
                : suggestionVideo?.status == 'Approved'
                ? 'success'
                : suggestionVideo?.status == 'Rejected'
                ? 'error'
                : 'default'
            }
          >
            {suggestionVideo?.status}
          </Label>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container rowSpacing={3}>
          <AppLabelWithValue
            label="Video Link"
            value={
              <Typography
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                fontWeight={500}
                onClick={showVideo.onTrue}
              >
                Preview
              </Typography>
            }
          />
          <AppLabelWithValue label="Video Title" value={suggestionVideo?.title} />
          <AppLabelWithValue label="Video Description" value={suggestionVideo?.description} />
          <AppLabelWithValue
            label="Created"
            value={new Date(suggestionVideo?.createdAt)?.toDateString()}
          />
        </Grid>
      </Grid>

      {/* Show Video Link */}
      {showVideo.value && (
        <Dialog maxWidth="md" open={showVideo.value} onClose={showVideo.onFalse}>
          <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
            <ReactPlayer url={suggestionVideo?.link} controls playing />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
